// @flow
export function setResolutionMax() {

  window.ready3d(() => {
    if (window.pc.app.graphicsDevice) {
      window.pc.app.graphicsDevice.maxPixelRatio = window.devicePixelRatio;
    }
    window.minPixelRatio = window.devicePixelRatio;
  });
}

export function setResolutionMin() {

  window.ready3d(() => {

    window.minPixelRatio = 1.0;
    if (window.pc.app.graphicsDevice) {
      window.pc.app.graphicsDevice.maxPixelRatio = window.minPixelRatio;
    }
    
  });
}

export function fireStartRace() {

  window.ready3d(() => {
    waitVREventListener("startRace", ()=>{
      setResolutionMax();
      window.SceneController.play("guide");
      window.pc.app.fire('startRace');
    });
  });
}

export function pause(value: string) {
  window.ready3d(() => {
    window.SceneController.pause(value);
  });
}

export function play(value: string) {
  window.ready3d(() => {
    window.SceneController.play(value);
  });

}

export function pauseGTModeGuide() {
  pause("GTModeGuide");
}

export function playGTModeGuide() {
  play("GTModeGuide");
}

type CallbackFunc = () => void;
type ReadyFunc = (callback?: CallbackFunc)=>void;
type NotReadyFunc = (CallbackFunc)=>void;
let EventWaitReadyQueue = {};

export function waitVREventListener(key: string, ready: ReadyFunc, notReady?: NotReadyFunc, timeoutDuration? : number ) {

  window.ready3d(()=>{
    if (window.pc.app.hasEvent(key)) {
      if (EventWaitReadyQueue[key] != null) {
        const events = EventWaitReadyQueue[key];
        for (var i = 0; i < events.length; ++i) {
          if (events[i].ready != null) {
            events[i].ready();
            events[i].ready = null;
          }
        }
        EventWaitReadyQueue[key] = [];
      }
      ready(()=>{});
      return;
    }

    if (EventWaitReadyQueue[key] == null) {
      EventWaitReadyQueue[key] = [];

      var intervalTimer;

      function clearTimer() {
        if (intervalTimer != null) {
          clearInterval(intervalTimer);
          intervalTimer = null;
        }
      }

      function check() {
        //console.log("waint for timer key");
        if (window.pc == null || window.pc.app == null || !window.pc.app.hasEvent(key)) {
          if (EventWaitReadyQueue[key] != null) {
            const entries = EventWaitReadyQueue[key];
            for (const entry of entries) {
              if (entry.notReady != null) {
                entry.notReady(entry.clear);
              }
            }
          }
          return false;
        }
        
        clearTimer();
        if (EventWaitReadyQueue[key] != null) {
          const entries = EventWaitReadyQueue[key];
          for (const entry of entries) {
            if (entry.ready != null) {
              entry.ready(entry.clear);
            }
          }
        }

        return true;
      }
      intervalTimer = setInterval(check, 500);
    }

    if (timeoutDuration == null) {
      timeoutDuration = 15;
    }
    
    var timeoutId;
    function clearTimeout0() {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }

    const entry = {ready:ready, notReady:notReady, clear:()=>{
      clearTimeout0();
      const idx = EventWaitReadyQueue[key].indexOf(entry);
      if (idx >= 0) {
        EventWaitReadyQueue[key].splice(idx, 1)
      }
    }};

    EventWaitReadyQueue[key].push( entry );
    
    timeoutId = setTimeout(function(){
      entry.clear();
      timeoutId = null;
    }, timeoutDuration * 1000);




  });

}

export function hasVREventListener(key: string) : boolean {
  if (window.pc == null || window.pc.app == null) {
    return false;
  }
  return window.pc.app.hasEvent(key);
}

export function getVRCanvas() : null | HTMLCanvasElement {
  if (window.pc == null || window.pc.app == null) {
    return null;
  }
  return window.pc.app.graphicsDevice.canvas;
}

export function getVRMaxPixelRatio() : number {
  if (window.pc == null || window.pc.app == null) {
    return 1.0;
  }
  return window.pc.app.graphicsDevice.maxPixelRatio;
}

export function setVRMaxPixelRatio(value:number){
  window.ready3d(()=>{
    window.pc.app.graphicsDevice.maxPixelRatio = value;
  });
}

export function setVRMinPixelRatio(value:number){
  window.ready3d(()=>{
    window.minPixelRatio = value;
  });
}

export function addVREventListener(key: string, callback: (...args: Array<any>) => void, thisObject : any ) {
  window.ready3d(() => {
    window.pc.app.on(key, callback, thisObject);
  });
}

export function removeVREventListener(key: string, callback: (...args: Array<any>) => void, thisObject : any) {
  window.ready3d(() => {
    window.pc.app.off(key, callback, thisObject);
  });
  
}

export function preloadAssets(tag:string, tags?: Array<string>, completion?: () => void) {
  window.ready3d(() => {
    window.SceneController.loadAssets(tag, completion, tags );
  });
}

export function getSceneName() : string {
  return window.lastSceneName;
}
export function loadScene(name: string, assets?: Array<string>, completion?: () => void) {
  window.lastSceneName = name;
  window.ready3d(() => {
    function completionCallback() {
      window.SceneController.play();
      window.pc.app.averageDeltaTimeData = null;
      window.lastLoadedSceneName = name;
      completion?.();
    }

    window.SceneController.load(name, completionCallback, assets ?? []);
  });
}

export function setAverageFPS(flag:boolean):void {
  window.pc.app.averageDeltaTimeCount = flag ? 60 : null;
  window.pc.app.averageDeltaTimeData = [];
  if (window.pc.app.averageDeltaTimeCount != null) {
    for (var i = 0; i < window.pc.app.averageDeltaTimeCount; ++i) {
      window.pc.app.averageDeltaTimeData.push(1.0 / 60.0);
    }
  }
}

export function unloadScene(completion?: () => void) {
  window.lastSceneName = "";
  window.ready3d(() => {
    completion?.();
  });
}

export function loadSceneColorSelect(colorCode: string, completion?: () => void) {
  loadScene("select_color", ["car0"], () => {
    applyCarColorCode(colorCode);
    completion?.();
    setAverageFPS(false);
  })
}

export function loadSceneColorSelect2(colorCode: string, completion?: () => void) {
  loadScene("select_color2", ["car1", "select_color"], () => {
    applyCarColorCode(colorCode);
    completion?.();
    setAverageFPS(false);
  })
}

export function preloadSceneColorSelectAssets() {
  preloadAssets("select_color", ["car0"]);
}

export function preloadSceneColorSelectAssets2() {
  preloadAssets("select_color", ["car1"]);
}

export function preloadAllSceneColorSelectAssets() {
  preloadAssets("select_color", ["car0", "car1"]);
}

export function applyCarColorCode(colorCode: string) {

  // window.ready3d(() => {

  // });
  waitVREventListener("color", ()=>{
    //console.log("color: color listener is ready");
    window.applyColorCode?.(colorCode, 0);
    window.applyColorCode?.(colorCode, 1);
    window.applyColorCode?.(colorCode, 2);
    
  }, undefined, 120);

}

export function fireVREvent(...args : Array<any> ) {
  //console.warn("fireVREvent:", args[0]);
  window.ready3d(() => {
    window.pc.app.fire.apply(window.pc.app, args);
  });
}

export function ready(callback : ()=>void ) {
  window.ready3d(callback);
}
